import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>

<MDXTag name="h2" components={components} props={{"id":"DO-NOT-USE-UNLESS-YOU-ARE-SURE"}}><MDXTag name="a" components={components} parentName="h2" props={{"href":"#DO-NOT-USE-UNLESS-YOU-ARE-SURE","aria-label":"DO NOT USE UNLESS YOU ARE SURE permalink","class":"anchor"}}></MDXTag>{`DO NOT USE UNLESS YOU ARE SURE`}</MDXTag>
<MDXTag name="p" components={components}>{`** Infinite scrolling is our preferred UX for long item lists`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"Raionatonale"}}><MDXTag name="a" components={components} parentName="h2" props={{"href":"#Raionatonale","aria-label":"Raionatonale permalink","class":"anchor"}}></MDXTag>{`Raionatonale`}</MDXTag>
<MDXTag name="p" components={components}>{`Having to use pagination breaks the user off from their task of viewing the list.
In conversion-sensitive contexts (like Jobs and Resources) this may lose us money because we believe the more people see what they want, the more they will interact with those things.`}</MDXTag>
           </MDXTag>
  }
}

export const _frontmatter = {};

  